var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentsArchiveLibrary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 5.99475V4.05558C4.1665 3.64302 4.33038 3.24735 4.62211 2.95562C4.91383 2.66389 5.3095 2.5 5.72206 2.5H14.2776C15.1367 2.5 15.8332 3.19645 15.8332 4.05556V5.99472",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4988 17.5H4.50107C3.62667 17.5 2.90094 16.8243 2.83864 15.9521L2.50431 11.2717C2.4708 10.8025 2.63382 10.3405 2.95437 9.99621C3.27492 9.65195 3.72414 9.45642 4.19453 9.45642H15.8054C16.2758 9.45642 16.725 9.65194 17.0455 9.99619C17.3661 10.3404 17.5291 10.8024 17.4956 11.2716L17.1612 15.9521C17.0989 16.8243 16.3732 17.5 15.4988 17.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5083 9.61012L16.6628 7.44689C16.6926 7.02984 16.5477 6.61917 16.2628 6.31316C15.9779 6.00716 15.5786 5.83337 15.1604 5.83337H4.83971C4.4216 5.83337 4.02229 6.00716 3.73737 6.31316C3.45244 6.61917 3.30753 7.02984 3.33733 7.44689L3.49185 9.61022",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentsArchiveLibrary);
export default ForwardRef;